export default __webpack_public_path__ + "static/media/tech5-black-logo.19224d8a.svg";